"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBScdNegative = function SvgBScdNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M66.346 131.41a2.262 2.262 0 01-2.262-2.262v-12.176a2.262 2.262 0 114.523 0v12.176a2.262 2.262 0 01-2.261 2.261zM66.346 77.918a2.262 2.262 0 01-2.262-2.261V63.594a2.262 2.262 0 014.523 0v12.063a2.262 2.262 0 01-2.261 2.261z"
  }), (0, _core.jsx)("path", {
    d: "M66.346 117.763a13.397 13.397 0 01-9.221-3.558 2.264 2.264 0 013.099-3.302 8.859 8.859 0 006.122 2.337c4.614 0 8.368-3.28 8.368-7.306 0-4.357-4.305-6.981-8.55-7.335a17.092 17.092 0 01-4.523-.958c-5.036-2.028-8.157-6.19-8.157-10.864v-.075a11.256 11.256 0 013.86-8.444 13.729 13.729 0 0118.094 0 2.262 2.262 0 01-3.016 3.355 9.205 9.205 0 00-12.017 0A6.785 6.785 0 0058 86.702v.083c0 2.834 1.99 5.322 5.322 6.672 1.043.354 2.128.57 3.227.64 7.358.611 12.704 5.58 12.704 11.822 0 6.537-5.783 11.844-12.907 11.844zM98.342 129.178a2.262 2.262 0 01-2.262-2.262V63.797a2.262 2.262 0 014.524 0v63.119a2.262 2.262 0 01-2.262 2.262zM34.311 129.178a2.262 2.262 0 01-2.262-2.262V63.797a2.262 2.262 0 014.524 0v63.119a2.262 2.262 0 01-2.262 2.262zM20.228 50.619a2.262 2.262 0 01-1.598-3.876L64.747.633a2.337 2.337 0 013.197 0l46.118 46.11a2.262 2.262 0 11-3.197 3.197L66.345 5.436l-44.481 44.52a2.262 2.262 0 01-1.636.663z"
  }), (0, _core.jsx)("path", {
    d: "M48.477 40.177a2.262 2.262 0 01-1.598-3.86l17.868-17.868a2.33 2.33 0 013.204 0l16.76 16.767a2.274 2.274 0 11-3.196 3.234l-15.17-15.206-16.27 16.277c-.424.421-.999.657-1.598.656zM20.002 129.178a2.262 2.262 0 01-2.262-2.262V62.764a2.262 2.262 0 012.262-2.261h101.026V50.8H11.603v12.153a2.262 2.262 0 01-4.524 0V48.538a2.262 2.262 0 012.262-2.262h113.971a2.262 2.262 0 012.262 2.262v14.226a2.262 2.262 0 01-2.262 2.262H22.286v61.89a2.262 2.262 0 01-2.284 2.262z"
  }), (0, _core.jsx)("path", {
    d: "M112.652 129.178a2.262 2.262 0 01-2.262-2.262V62.764a2.262 2.262 0 114.524 0v64.152a2.262 2.262 0 01-2.262 2.262z"
  }), (0, _core.jsx)("path", {
    d: "M123.38 132.691H9.35a2.262 2.262 0 110-4.523H123.38a2.262 2.262 0 010 4.523zM130.603 143.517H2.262a2.262 2.262 0 010-4.523h128.34a2.262 2.262 0 010 4.523z"
  })));
};

var _default = SvgBScdNegative;
exports["default"] = _default;